import { render } from "./OptionSelectorPlaceholders.vue?vue&type=template&id=5270b700&scoped=true"
import script from "./OptionSelectorPlaceholders.vue?vue&type=script&lang=js"
export * from "./OptionSelectorPlaceholders.vue?vue&type=script&lang=js"

import "./OptionSelectorPlaceholders.vue?vue&type=style&index=0&id=5270b700&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5270b700"]])

export default __exports__